// export const SOCKET_URL = "https://feed.thebusybee.app";
export const RAZOR_PAY_SUBSCRIPTION_URL =
  "https://api.razorpay.com/v1/subscriptions";
export const RAZOR_PAY_BASE_URL = "https://api.razorpay.com/v1";
export const RAZOR_PAY_KEY_ID = "rzp_test_L4y34Di6IO1ErA";
export const RAZOR_PAY_KEY_SECRET = "iVJcf6oKwPUiZcsCpfiqu3x4";
export const BUCKET_URL = "https://bucket.thebusybee.app/busybee/";
export const MAPS_API_KEY = "AIzaSyBZqznPMqyl0vYkCKbf-AAybd-0Tm6gENA";
export const SERVER_URL = "https://husky.thebusybee.app";
